const triggerGAEvent = (eventName: string, eventParams: Gtag.ControlParams | Gtag.CustomParams | Gtag.EventParams) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', eventName, eventParams);
        // eslint-disable-next-line no-console
        console.log(`${eventName} triggered`);
    }
};

export default triggerGAEvent;
